import { lazy } from 'react';

const Vehicle = lazy(() =>
  import('components/Vehicles/Details').then((module) => ({
    default: module.VehicleDetailsWidget,
  }))
);
const User = lazy(() => import('components/Users/Details'));
const ReservationDriver = lazy(() => import('components/Reservations/Details'));

export { Vehicle, User, ReservationDriver };
